export const MG = 'MG'
export const G = 'G'
export const LBR = 'LBR'
export const KG = 'KG'

const titles = {
    [MG]: 'мг.',
    [G]: 'г.',
    [LBR]: 'ф.',
    [KG]: 'кг.'
}

export const getWeight = (type) => {
    return titles[type]
}